





























































































































































































































import { Vue, Component, Emit } from 'vue-property-decorator';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import ProfileRatingStar from '@/components/profile/profileParts/ProfileRatingStar.vue';
import ProfileEvaluationCard from '@/components/profile/profileParts/ProfileEvaluationCard.vue';

@Component({
  components: {
    CommonModalHeader,
    AccountIcon,
    CommonButton,
    ProfileRatingStar,
    ProfileEvaluationCard,
  },
})
export default class ProfileEditBasic extends Vue {
  private profileStepCount: number = 1;
  private isOpenUpdateHeaderPhotoModal: boolean = false;
  private isOpenAddSkillCard: boolean = false;
  private isRenameModalOpen: boolean = false;
  private accountName: string = 'セオリー太郎';
  private modalHeaderTitle: string = '画像位置を選択してください';
  private modalMode: string = 'add';
  private isPublic: boolean = false;
  private rating: string = '4.5';

  // テストデータ
  private jobs: Array<string> = [
    'フロントエンドエンジニア',
    'バックエンドエンジニア',
    'インフラエンジニア',
    'iOS/Androidエンジニア',
  ];
  private genders: Array<string> = ['男性', '女性', 'その他', '無回答'];
  private prefectures: Array<string> = ['東京都', '神奈川県', '北海道'];
  private cities: Array<string> = ['川崎市', '草加市', '北九州市'];

  // ヘッダー画像選択処理
  private openHeaderExplorer(): void {
    const headerExplorer = this.$refs.headerExplorer as HTMLElement;
    headerExplorer.click();
  }
  private readHeaderImage(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files!.length) {
      this.isOpenUpdateHeaderPhotoModal = false;
      return;
    }

    const reader = new FileReader();
    reader.onload = (loadEvent) => {
      if (loadEvent.target) {
        this.$refs.headerRef.bind({
          url: loadEvent.target.result,
        });
      }
    };
    this.isOpenUpdateHeaderPhotoModal = true;
    reader.readAsDataURL(files![0]);
  }

  @Emit('closeUpdateHeaderPhotoModal')
  private closeUpdateHeaderPhotoModal(): void {
    this.isOpenUpdateHeaderPhotoModal = false;
  }

  private addSkill() {
    this.isOpenAddSkillCard = true;
  }

  private closeInvitation() {
    this.isOpenAddSkillCard = false;
  }

  private renameAccountName(event: string) {
    this.accountName = event;
    this.isRenameModalOpen = false;
  }
}
